import { areBothMissing } from "../../../../utils/line-item-matchers/shared.js";
const areSameOpticianDetails = (server, draft) => {
  if (areBothMissing(draft.opticianDetails, server.opticianDetails)) {
    return true;
  } else if (!draft.opticianDetails || !server.opticianDetails) {
    return false;
  }
  for (const field of Object.getOwnPropertyNames(draft.opticianDetails)) {
    const serverValue = server.opticianDetails[field];
    const draftValue = draft.opticianDetails[field];
    if (areBothMissing(serverValue, draftValue)) {
      continue;
    }
    if (serverValue !== draftValue) {
      return false;
    }
  }
  return true;
};
export {
  areSameOpticianDetails
};
//# sourceMappingURL=optician-details.js.map
